// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-22c9e31a] .avue-crud__pagination .el-pagination{display:inline-block!important}", ""]);
// Exports
module.exports = exports;
